export const EXPLORERS_JOURNAL = {
  SANITY_TYPES: {
    CITY_GUIDE: 'cityGuide',
    NEIGHBORHOOD_GUIDE: 'neighborhoodGuide',
    LIVE_LIKE_A_LOCAL: 'journal',
    EVENTS: 'event'
  }
};
